// 导入各个模块
// import test from './test'

// import bankCardManage from './bank-card-manage'
import myAccount from './my-account' // 我的账户

import SpotPurchaseSaleInquiry from './spot-purchase-sale-inquiry' // 现货购销查询
import othersInquiry from './others-inquiry' // 其他查询
import productLineReport from './product-line-report' // 产品线报表
import myStore from './my-store' // 产品线报表
import transation from './transation' // 交易管理
import contract from './contract'
// 统一导出
export default [
  // test,
  myStore,
  myAccount,
  // bankCardManage
  SpotPurchaseSaleInquiry,
  othersInquiry,
  productLineReport,
  transation,
  contract,
]
